import React, { useEffect } from 'react';
import { QtcRenderer } from '@3plearning/question-components-library';
import { Box } from '@chakra-ui/react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { getValueFromUrl, randomiseQuestionMCQOptions } from '../../../helpers/utils';
import { useMeasurementTools } from './hooks/use-measurement-tools';
import { updateStudentAnswer, stopLoadingActivity } from '../conquest.actions';
import { disableSpinner } from '../../spinner/spinner-actions';
import { LEARNOSITY_SPINNER } from '../../../helpers/constants';
import css from './qtc.scss';

const Qtc = ({ keypadRef, readAloudConfig }) => {
  const dispatch = useDispatch();
  const { conquestReducer, mleReducer } = useSelector(state => state);
  const {
    isMarked,
    conquestQuestionId,
    conquestData,
    conquestMeasurementTools,
    conquestValidation,
    conquestUserResponse
  } = conquestReducer;
  const { isCompleted } = mleReducer;
  const keypadPresetFromQueryParams = getValueFromUrl('keypadPreset');
  const { tools, setupTools } = useMeasurementTools();

  useEffect(() => {
    setupTools(conquestMeasurementTools);
    dispatch(disableSpinner(LEARNOSITY_SPINNER));
    dispatch(stopLoadingActivity());
  }, [conquestMeasurementTools]);

  const feedback = ({ answer, isReady }) => {
    dispatch(updateStudentAnswer({
      conquestUserAnswer: answer,
      conquestIsReady: isReady
    }));
  };

  const validationState = () => {
    let validation = null;

    if (isCompleted && conquestValidation) {
      validation = conquestValidation;
    } else if (conquestUserResponse) {
      validation = {
        isCorrect: false,
        validAnswer: {},
        sectionResults: {}
      };
    }

    return validation;
  };

  return (
    <Box
      className={!isCompleted ? css['no-validation'] : ''}
      key={`${conquestQuestionId}${isMarked ? '-validated' : ''}`}
    >
      {keypadRef.current && <QtcRenderer
        question={randomiseQuestionMCQOptions(conquestData)}
        callback={feedback}
        validation={validationState()}
        keypadPreset={
          keypadPresetFromQueryParams ? Number(keypadPresetFromQueryParams) : 3
        }
        keypadContainer={keypadRef.current}
        readAloudConfig={readAloudConfig}
        {...isCompleted && validationState() && {
          userResponse: Object.keys(validationState().validAnswer).reduce((acc, key) => {
            const userAnswer = conquestUserResponse ? conquestUserResponse[key] : undefined;
            acc[key] = Array.isArray(
              validationState().validAnswer[key]
            ) && !userAnswer ? [] : userAnswer;
            return acc;
          }, {}) }
        }
        {...!isCompleted && { userResponse: conquestUserResponse || {} }}
        measurementTools={tools}
      />}
    </Box>
  );
};

Qtc.propTypes = {
  keypadRef: PropTypes.object.isRequired,
  readAloudConfig: PropTypes.object.isRequired
};

export default Qtc;
